import { CSSProperties, MouseEventHandler } from 'react';
import classNames from 'classnames';

import { TypographyProps } from '@hcs/types';

import { classNamesTypography } from '../../../../utils';

import styles from './Flex.module.css';
export interface FlexProps extends TypographyProps {
  className?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
  children: React.ReactNode;
  /** Flex CSS Rules w/ */
  direction?: CSSProperties['flexDirection'];
  alignItems?: CSSProperties['alignItems'];
  alignContent?: CSSProperties['alignContent'];
  wrap?: boolean;
  justifyContent?: CSSProperties['justifyContent'];
  gap?: CSSProperties['gap'];
  columnOnPhone?: boolean;
  columnOnMobile?: boolean;
  style?: CSSProperties;
  flex?: CSSProperties['flex'];
  onClick?: MouseEventHandler<HTMLDivElement>;
  testId?: string; // last resort for special cases
}
export const Flex = ({
  className,
  children,
  gap,
  direction = 'row',
  alignItems = 'center',
  wrap,
  justifyContent = 'flex-start',
  alignContent,
  fullWidth,
  fullHeight,
  columnOnPhone,
  columnOnMobile,
  style,
  flex,
  testId,
  onClick,
  ...typographyProps
}: FlexProps) => {
  return (
    <div
      onClick={onClick}
      data-testid={testId}
      style={{ gap, flex, ...style }}
      className={classNames(
        styles.Flex,
        className,
        classNamesTypography(typographyProps),
        {
          [styles.fullWidth]: fullWidth,
          [styles.fullHeight]: fullHeight,
          [styles.directionColumn]: direction === 'column',
          [styles.directionRow]: direction === 'row',
          [styles.directionRowReverse]: direction === 'row-reverse',
          [styles.directionColumnReverse]: direction === 'column-reverse',
          [styles.wrap]: wrap === true,
          [styles.justifyContentCenter]: justifyContent === 'center',
          [styles.justifyContentStart]: justifyContent === 'flex-start',
          [styles.justifyContentEnd]: justifyContent === 'flex-end',
          [styles.justifyContentBetween]: justifyContent === 'space-between',
          [styles.justifyContentAround]: justifyContent === 'space-around',
          [styles.justifyContentStretch]: justifyContent === 'stretch',
          [styles.alignItemsCenter]: alignItems === 'center',
          [styles.alignItemsStart]: alignItems === 'flex-start',
          [styles.alignItemsEnd]: alignItems === 'flex-end',
          [styles.alignItemsStretch]: alignItems === 'stretch',
          [styles.alignItemsBaseline]: alignItems === 'baseline',
          [styles.alignContentStart]: alignContent === 'flex-start',
          [styles.alignContentCenter]: alignContent === 'center',
          [styles.alignContentEnd]: alignContent === 'flex-end',
          [styles.alignContentBetween]: alignContent === 'space-between',
          [styles.alignContentAround]: alignContent === 'space-around',
          [styles.alignContentStretch]: alignContent === 'stretch',
          [styles.alignContentBaseline]: alignContent === 'baseline',
          [styles.columnOnPhone]: columnOnPhone,
          [styles.columnOnMobile]: columnOnMobile,
        },
      )}
    >
      {children}
    </div>
  );
};
